import React, { useContext, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField/TextField";
import { FormattedMessage, useIntl } from "react-intl";
import RoomContext from "../../../context/RoomContext";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { useSelector } from "react-redux";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      padding: 20,
    },
    textFields: {
      height: 48,
      borderRadius: 8,
    },
    choiceTextFields: {
      height: 48,
      borderRadius: 8,
      marginLeft: 18,
    },
    buttonPublish: {
      height: 45,
    },
    actionButtonRoot: {
      display: "flex",
      flexDirection: "row",
    },
    redButton: {
      color: "#ffffff",
      backgroundColor: "#F3465A",
      height: 45,
      "&:hover": {
        backgroundColor: "rgba(243,70,90,0.75)",
      },
    },
    addButton: {
      color: "#3289ef",
    },
  })
);

const SurveyCreator = () => {
  const classes = useStyles();
  const intl = useIntl();
  const { roomClient } = useContext(RoomContext);
  const currentSurvey = useSelector((state) => state.survey.currentSurvey);
  const [question, setQuestion] = useState("");
  const [choices, setChoices] = useState([]);
  const [newChoice, setNewChoice] = useState("");
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    setCounter(question.length);
  }, [question]);

  return (
    <div className={classes.root}>
      {!currentSurvey && (
        <div>
          <TextField
            id="question"
            className={classes.textFields}
            label={intl.formatMessage({
              id: "survey.question",
              defaultMessage: "Question",
            })}
            inputProps={{ maxLength: 255 }}
            variant="standard"
            margin="normal"
            value={question}
            onChange={(event) => {
              setQuestion(event.target.value);
            }}
            fullWidth
            InputProps={{
              disableUnderline: true,
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
              }
            }}
          />
          <p style={{ color: "gray", margin: 0, marginLeft: "80%" }}>
            {counter} / 255
          </p>

          {choices.map((choice, index) => {
            return (
              <TextField
                id="choice"
                className={classes.choiceTextFields}
                label={
                  intl.formatMessage({
                    id: "survey.choice",
                    defaultMessage: "Choice",
                  }) +
                  " " +
                  (index + 1)
                }
                variant="standard"
                margin="normal"
                value={choice.text}
                onChange={(event) => {
                  choices[index].text = event.target.value;
                  setChoices([...choices]);
                }}
                fullWidth
                InputProps={{
                  disableUnderline: true,
                }}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                  }
                }}
              />
            );
          })}

          <TextField
            id="choice"
            className={classes.textFields}
            label={intl.formatMessage({
              id: "survey.newChoice",
              defaultMessage: "New Choice",
            })}
            variant="standard"
            margin="normal"
            value={newChoice}
            onChange={(event) => {
              setNewChoice(event.target.value);
            }}
            fullWidth
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <IconButton
                  className={classes.addButton}
                  onClick={(e, v) => {
                    if (newChoice.trim() !== "") {
                      setChoices([
                        ...choices,
                        { id: choices.length, text: newChoice },
                      ]);
                      setNewChoice("");
                    }
                  }}
                >
                  <AddIcon />
                </IconButton>
              ),
            }}
            onKeyPress={(e) => {
              if (e.key === "Enter" && e.target.value.trim() !== "") {
                setChoices([
                  ...choices,
                  { id: choices.length, text: e.target.value },
                ]);
                setNewChoice("");
              }
            }}
          />
        </div>
      )}

      {currentSurvey && (
        <Button
          className={classes.redButton}
          autoFocus
          color="primary"
          variant="contained"
          onClick={() => {
            roomClient.publishSurvey(null);
            setChoices([]);
            setQuestion("");
            setNewChoice("");
          }}
        >
          <FormattedMessage
            id="survey.unPublish"
            defaultMessage="Unpublish Survey"
          />
        </Button>
      )}

      {!currentSurvey && (
        <div className={classes.actionButtonRoot}>
          <Button
            className={classes.redButton}
            autoFocus
            color="primary"
            variant="contained"
            onClick={() => {
              setChoices([]);
              setQuestion("");
              setNewChoice("");
            }}
          >
            <FormattedMessage id="survey.clear" defaultMessage="Clear" />
          </Button>

          <Button
            className={classes.buttonPublish}
            autoFocus
            color="primary"
            variant="contained"
            disabled={choices.length > 0 ? false : true}
            onClick={() => {
              let surveyBody = {
                question,
                choices,
              };
              roomClient.publishSurvey(surveyBody);
              setChoices([]);
              setQuestion("");
              setNewChoice("");
            }}
          >
            <FormattedMessage
              id="survey.publish"
              defaultMessage="Publish Survey"
            />
          </Button>
        </div>
      )}
    </div>
  );
};

export default SurveyCreator;
